/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_SchoolvakantiesInputs */

const nl_planning_vakanties_schoolvakanties = /** @type {(inputs: Planning_Vakanties_SchoolvakantiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schoolvakanties en feestdagen`)
};

/**

* @param {Planning_Vakanties_SchoolvakantiesInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_schoolvakanties = /** @type {((inputs?: Planning_Vakanties_SchoolvakantiesInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_SchoolvakantiesInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_schoolvakanties(inputs)
});
export { planning_vakanties_schoolvakanties as "planning.vakanties.schoolvakanties" }